import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Box } from "../../Box/Box.mjs";
import { FieldButtonIcon } from "../FieldButtonIcon/FieldButtonIcon.mjs";
const ActionField = ({ hide = false, onAction, label = "Action", id, icon }) => {
  const actionHandler = useCallback(
    (event) => {
      if (typeof onAction !== "function" || event.button !== 0) {
        return;
      }
      onAction(event);
    },
    [onAction]
  );
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      width: "touchable",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "fast",
      pointerEvents: hide ? "none" : void 0,
      opacity: hide ? 0 : void 0,
      cursor: "pointer",
      children: /* @__PURE__ */ jsx(FieldButtonIcon, { id, label, icon, onMouseDown: actionHandler })
    }
  );
};
export {
  ActionField
};
